import { TextField } from "@mui/material";
import React from "react";

export interface CustomInputProps {
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  sx?: React.CSSProperties;
}
export const CustomInputComponent: React.FC<CustomInputProps> = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  disabled = false,
  sx,
}) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      sx={{
        ...sx,
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          backgroundColor: "transparent",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#e0d7dd", // light border color
        },
        "& .MuiOutlinedInput-input": {
          padding: "12px",
          fontSize: "13px",
          color: "#2d2d2d", // dark text color
        },
        "& .MuiInputLabel-root": {
          fontSize: "13px",
          color: "#c2b7bd", // label color
        },
      }}
    />
  );
};
